import { Controller } from "@hotwired/stimulus";
import debounce from "../lib/debounce";

export default class extends Controller {
  static targets = ["field", "frame", "spinner", "eanField", "carryField"];
  static values = { url: String };

  initialize() {
    this.navigate = debounce(this.navigate.bind(this), 400);
  }

  connect() {
    this.form = this.element.closest("form");
    this.onSubmit = this.onSubmit.bind(this);
    this.hideSpinner = this.hideSpinner.bind(this);
    this.form?.addEventListener("submit", this.onSubmit);
    document.addEventListener("turbo:before-cache", this.hideSpinner);
  }

  disconnect() {
    this.form?.removeEventListener("submit", this.onSubmit);
    document.removeEventListener("turbo:before-cache", this.hideSpinner);
    this.navigate.cancel();
  }

  hideSpinner() {
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.add("hidden");
  }

  onSubmit(event) {
    if (event.submitter?.getAttribute("formmethod") !== "get") return;

    event.preventDefault();

    if (this.fieldTargets.includes(document.activeElement)) {
      this.navigate();
    } else {
      requestAnimationFrame(() => this.form.requestSubmit());
    }
  }

  search(event) {
    event.preventDefault();
    this.navigate({ skipWhileTypingAddress: event.type === "blur" });
  }

  reselectAddress() {
    this.navigate({ keepSelectedAddress: true });
  }

  chooseEan(event) {
    if (this.hasEanFieldTarget) this.eanFieldTarget.value = event.target.value;
  }

  navigate({ keepSelectedAddress = false, skipWhileTypingAddress = false } = {}) {
    if (skipWhileTypingAddress && this.fieldTargets.includes(document.activeElement)) return;

    const params = new URLSearchParams();

    this.fieldTargets.forEach((field) => {
      if (field.value !== "") params.set(field.name, field.value);
    });

    if (keepSelectedAddress) {
      const selectedAddress = this.element.querySelector("input[name='selected_address']:checked");
      if (selectedAddress) params.set("selected_address", selectedAddress.value);
    }

    this.carryFieldTargets.forEach((field) => {
      if (field.value !== "") params.set(field.name, field.value);
    });

    if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("hidden");

    this.frameTarget.src = `${this.urlValue}?${params.toString()}`;
  }
}
